var map = {
	"./axiforma-bold.woff": 73,
	"./axiforma-bold.woff2": 74,
	"./axiforma-heavy.woff": 75,
	"./axiforma-heavy.woff2": 76,
	"./axiforma-regular.woff": 77,
	"./axiforma-regular.woff2": 78,
	"./nunito-v16-latin-700.eot": 79,
	"./nunito-v16-latin-700.svg": 80,
	"./nunito-v16-latin-700.ttf": 81,
	"./nunito-v16-latin-700.woff": 82,
	"./nunito-v16-latin-700.woff2": 83,
	"./nunito-v16-latin-regular.eot": 84,
	"./nunito-v16-latin-regular.svg": 85,
	"./nunito-v16-latin-regular.ttf": 86,
	"./nunito-v16-latin-regular.woff": 87,
	"./nunito-v16-latin-regular.woff2": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;